<template>
  <div class="all">
    <div class="switch">
      <el-button @click="changeswitch(2)" size="small" :type="switchValue === 2 ? 'primary' : ''">志愿方案</el-button>
      <el-button :label="1" @click="changeswitch(1)" size="small" :type="switchValue === 1 ? 'primary' : ''">院校志愿
      </el-button>
      <el-button :label="2" @click="changeswitch(3)" size="small" v-if="volunteerMode === 3"
                 :type="switchValue === 3 ? 'primary' : ''">专业组志愿
      </el-button>
    </div>
    <!-- 院校志愿 -->
    <div class="table" v-if="switchValue === 1">
      <el-table size="mini"  style="width: 100%" ref="schoolTable" :data="collegeList" :max-height="tableHeigth"
                :row-class-name="tableRowClassName" border row-key="specialtyUuid"
                :header-cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
                :cell-style="{ 'text-align': 'center', 'font-size': '14px'}"
                @selection-change="handleSelectionSchoolChange" @row-click="handleRowSelectionChangeschool">
        <el-table-column prop="aspirationName" label="志愿" width="60">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="collegeCode" label="院校代码" width="90"></el-table-column>
        <el-table-column prop="collegeName" label="院校名称" :show-overflow-tooltip="true" min-width="150">
        </el-table-column>
        <el-table-column prop="collegeCharacter" label="特性" width="130" show-overflow-tooltip>
          <template slot-scope="scope">
<!--            <span v-if="scope.row.collegeCharacter &&-->
<!--              scope.row.collegeCharacter.includes('2')-->
<!--              ">985-->
<!--            </span>-->
<!--            <span v-if="scope.row.collegeCharacter &&-->
<!--              scope.row.collegeCharacter.includes('1')-->
<!--              ">211-->
<!--            </span>-->
<!--            <span v-if="scope.row.collegeCharacter &&-->
<!--              scope.row.collegeCharacter.includes('3')-->
<!--              ">双一流</span>-->
<!--            <span v-if="!scope.row.collegeCharacter">{{-->
<!--                matchRunType(scope.row.runType)-->
<!--              }}</span>-->
            <span v-if="scope.row.collegeTag">{{scope.row.collegeTag}}</span>
            <span v-if="scope.row.collegeTag && scope.row.collegeCharacter">&nbsp;&nbsp;</span>
            <span v-if="scope.row.collegeCharacter">{{scope.row.collegeCharacter}}</span>
          </template>
        </el-table-column>
        <el-table-column label="专业数量" width="90" v-if="volunteerMode !== 3" key="specialtyList">
          <template slot-scope="scope">
            <div
                :class="scope.row.specialtyList ? scope.row.specialtyList.length >= 1 ? scope.row.specialtyList[0].specialtyName ? '' : 'colorRed' : 'colorRed' : 'colorRed'">
              {{
                scope.row.specialtyList ? scope.row.specialtyList.length === 1 ?
                    scope.row.specialtyList[0].specialtyName
                        ? '1' : '0' : scope.row.specialtyList.length : '0'
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="专业组数量" width="100" v-if="volunteerMode === 3" key="optionsList">
          <template slot-scope="scope">
            <div :class="scope.row.optionsList ? (scope.row.optionsList.length > 0 ? '' : 'colorRed') : 'colorRed'">
              {{ scope.row.optionsList ? scope.row.optionsList.length : '0' }}
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="specialtyNames" label="专业组代码" width="100" v-if="volunteerMode === 3"></el-table-column>
        <el-table-column prop="specialtyOptions" label="专业组名称" :show-overflow-tooltip="true" min-width="150" v-if="volunteerMode === 3"></el-table-column> -->
        <el-table-column width="65">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'score_year_this')">
              {{ admissionYear }}最低分
              <!-- <span @click="updateDraftPlanSort(false,'score_year_this')"><i class="el-icon-caret-top"></i></span>
              <span @click="updateDraftPlanSort(true,'score_year_this')"><i class="el-icon-caret-bottom"></i></span> -->
            </div>
          </template>
          <template slot-scope="scope">
            <div v-if="scope.row.scoreYearThis === null">0</div>
            <div v-else>{{ scope.row.scoreYearThis }}</div>
          </template>
        </el-table-column>
        <!-- <el-table-column :label="year - 2 + '最低分'" width="65">
          <template slot-scope="scope">
            <div v-if="scope.row.scoreYearLast === null">0</div>
            <div v-else>{{scope.row.scoreYearLast}}</div>
          </template>
        </el-table-column> -->
        <el-table-column width="68">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'accumulate_year_this')">
              {{ admissionYear }}最低位次
              <!-- <span @click="updateDraftPlanSort(false,'accumulate_year_this')"><i class="el-icon-caret-top"></i></span>
              <span><i class="el-icon-caret-bottom" @click="updateDraftPlanSort(true,'accumulate_year_this')"></i></span> -->
            </div>
          </template>
          <template slot-scope="scope">
            <div v-if="scope.row.accumulateYearThis === null">0</div>
            <div v-else>{{ scope.row.accumulateYearThis }}</div>
          </template>
        </el-table-column>
        <el-table-column width="68">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'accumulate_year_last')">
              {{ admissionYear - 1 }}最低位次
              <!-- <span @click="updateDraftPlanSort(false,'accumulate_year_last')"><i class="el-icon-caret-top"></i></span>
              <span @click="updateDraftPlanSort(true,'accumulate_year_last')"><i class="el-icon-caret-bottom"></i></span> -->
            </div>
          </template>
          <template slot-scope="scope">
            <div v-if="scope.row.accumulateYearLast === null">0</div>
            <div v-else>{{ scope.row.accumulateYearLast }}</div>
          </template>
        </el-table-column>
        <el-table-column width="68">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'accumulate_year_other')">
              {{ admissionYear - 2 }}最低位次
              <!-- <span @click="updateDraftPlanSort(false,'accumulate_year_other')"><i class="el-icon-caret-top"></i></span>
              <span @click="updateDraftPlanSort(true,'accumulate_year_other')"><i class="el-icon-caret-bottom"></i></span> -->
            </div>
          </template>
          <template slot-scope="scope">
            <div v-if="scope.row.accumulateYearOther === null">0</div>
            <div v-else>{{ scope.row.accumulateYearOther }}</div>
          </template>
        </el-table-column>
        <el-table-column width="65">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'plan_year_last')">
              {{ year - 1 }}计划数
              <!-- <span @click="updateDraftPlanSort(false,'plan_year_last')"><i class="el-icon-caret-top"></i></span>
              <span @click="updateDraftPlanSort(true,'plan_year_last')"><i class="el-icon-caret-bottom"></i></span> -->
            </div>
          </template>
          <template slot-scope="scope">
            <div v-if="scope.row.planYearLast === null">0</div>
            <div v-else>{{ scope.row.planYearLast }}</div>
          </template>
        </el-table-column>
        <el-table-column width="65">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'plan_year_this')">
              {{ year }}计划数
              <!-- <span @click="updateDraftPlanSort(false,'plan_year_this')"><i class="el-icon-caret-top"></i></span>
              <span @click="updateDraftPlanSort(true,'plan_year_this')"><i class="el-icon-caret-bottom"></i></span> -->
            </div>
          </template>
          <template slot-scope="scope">
            <div v-if="scope.row.planYearThis === null">0</div>
            <div v-else>{{ scope.row.planYearThis }}</div>
          </template>
        </el-table-column>
        <el-table-column label="计划增减" width="80">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'plan_diff')">
              计划增减
              <!-- <span @click="updateDraftPlanSort(false,'plan_diff')"><i class="el-icon-caret-top"></i></span>
              <span @click="updateDraftPlanSort(true,'plan_diff')"><i class="el-icon-caret-bottom"></i></span> -->
            </div>
          </template>
          <template slot-scope="scope">
            <div v-if="scope.row.planDiff === null">0</div>
            <div v-else>{{ scope.row.planDiff }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序" width="80"></el-table-column>
<!--        <el-table-column label="排序" width="80">-->
<!--          <template slot-scope="scope">-->
<!--            <input size="small" @click.stop="kong($event)" v-model="scope.row.sort" disabled-->
<!--                   @blur="changesortcollegeList(scope.row, scope.$index)"-->
<!--                   style="width: 26px;text-align:center;padding-left:10px;padding-right:10px"></input>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="操作" width="180">-->
<!--          <template slot-scope="scope">-->
<!--            <el-button style="font-size:14px;" type="text" @click.stop="showaddmajor(scope.row)" v-if="volunteerMode !== 3">-->
<!--              添加专业-->
<!--            </el-button>-->
<!--            <el-button style="font-size:14px;" type="text" v-if="volunteerMode === 3"-->
<!--                       @click.stop="addVolunteerOptionsClick(1, scope.row)">添加专业组-->
<!--            </el-button>-->
<!--            <el-button style="font-size:14px;" type="text" @click.stop="eidit(scope.row)">编辑</el-button>-->
<!--            <el-button type="text" style="color: #f56c6c;font-size:14px;" @click.stop="delcollegeList(scope.$index)">删除-->
<!--            </el-button>-->
<!--          </template>-->
<!--        </el-table-column>-->
      </el-table>
    </div>
    <!-- 专业组志愿 -->
    <div class="table" v-if="(volunteerMode === 3) && switchValue === 3">
      <!-- :span-method="objectOneMethod" -->
      <el-table size="mini"  ref="optionsTable" row-key="specialtyUuid" :max-height="tableHeigth" style="width: 100%"
                :row-class-name="tableRowClassName" :data="optionsList" border
                :header-cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
                :cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
                @selection-change="handleSelectionOptionsChange" @row-click="handleRowSelectionChangeOptions">
        <el-table-column prop="aspirationName" label="志愿" width="60">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="specialtyNames" label="专业组代码" width="100"></el-table-column>
        <el-table-column prop="specialtyOptions" label="专业组名称" :show-overflow-tooltip="true" min-width="150">
        </el-table-column>
        <el-table-column prop="collegeCharacter" label="特性" width="130" show-overflow-tooltip>
          <template slot-scope="scope">
<!--            <span v-if="scope.row.collegeCharacter &&-->
<!--              scope.row.collegeCharacter.includes('2')-->
<!--              ">985-->
<!--            </span>-->
<!--            <span v-if="scope.row.collegeCharacter &&-->
<!--              scope.row.collegeCharacter.includes('1')-->
<!--              ">211-->
<!--            </span>-->
<!--            <span v-if="scope.row.collegeCharacter &&-->
<!--              scope.row.collegeCharacter.includes('3')-->
<!--              ">双一流</span>-->
<!--            <span v-if="!scope.row.collegeCharacter">{{-->
<!--                matchRunType(scope.row.runType)-->
<!--              }}</span>-->
            <span v-if="scope.row.collegeTag">{{scope.row.collegeTag}}</span>
            <span v-if="scope.row.collegeTag && scope.row.collegeCharacter">&nbsp;&nbsp;</span>
            <span v-if="scope.row.collegeCharacter">{{scope.row.collegeCharacter}}</span>
          </template>
        </el-table-column>
        <el-table-column label="包含专业" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.aspirationName ? scope.row.aspirationName : "无" }}
          </template>
        </el-table-column>
        <el-table-column label="选考科目要求" min-width="150" show-overflow-tooltip>0
          <template slot-scope="scope">
            <span>{{ matchRequiredType(scope.row.requiredType) }}</span>
            <span v-if="scope.row.requiredType !== 0">{{ scope.row.requiredDiscipline }}</span>
          </template>
        </el-table-column>
        <el-table-column label="专业数量" width="90">
          <template slot-scope="scope">
            <div
                :class="scope.row.specialtyList ? scope.row.specialtyList.length >= 1 ? scope.row.specialtyList[0].specialtyName ? '' : 'colorRed' : 'colorRed' : 'colorRed'">
              {{
                scope.row.specialtyList ? scope.row.specialtyList.length === 1 ?
                    scope.row.specialtyList[0].specialtyName
                        ? '1' : '0' : scope.row.specialtyList.length : '0'
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column width="65">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'score_year_this')">
              {{ admissionYear }}最低分
              <!-- <span @click="updateDraftPlanSort(false,'score_year_this')"><i class="el-icon-caret-top"></i></span>
              <span @click="updateDraftPlanSort(true,'score_year_this')"><i class="el-icon-caret-bottom"></i></span> -->
            </div>
          </template>
          <template slot-scope="scope">
            {{ scope.row.scoreYearThis ? scope.row.scoreYearThis : '0' }}
          </template>
        </el-table-column>
        <!-- <el-table-column :label="year - 2 + '最低分'" width="65">
          <template slot-scope="scope">
            {{scope.row.scoreYearLast ? scope.row.scoreYearLast : '0'}}
          </template>
        </el-table-column> -->
        <el-table-column width="68">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'accumulate_year_this')">
              {{ admissionYear }}最低位次
              <!-- <span @click="updateDraftPlanSort(false,'accumulate_year_this')"><i class="el-icon-caret-top"></i></span>
              <span @click="updateDraftPlanSort(true,'accumulate_year_this')"><i class="el-icon-caret-bottom"></i></span> -->
            </div>
          </template>
          <template slot-scope="scope">
            {{ scope.row.accumulateYearThis ? scope.row.accumulateYearThis : '0' }}
          </template>
        </el-table-column>
        <el-table-column width="68">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'accumulate_year_last')">
              {{ admissionYear - 1 }}最低位次
              <!-- <span @click="updateDraftPlanSort(false,'accumulate_year_last')"><i class="el-icon-caret-top"></i></span>
              <span @click="updateDraftPlanSort(true,'accumulate_year_last')"><i class="el-icon-caret-bottom"></i></span> -->
            </div>
          </template>
          <template slot-scope="scope">
            {{ scope.row.accumulateYearLast ? scope.row.accumulateYearLast : '0' }}
          </template>
        </el-table-column>
        <el-table-column width="68">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'accumulate_year_other')">
              {{ admissionYear - 2 }}最低位次
              <!-- <span @click="updateDraftPlanSort(false,'accumulate_year_other')"><i class="el-icon-caret-top"></i></span>
              <span @click="updateDraftPlanSort(true,'accumulate_year_other')"><i class="el-icon-caret-bottom"></i></span> -->
            </div>
          </template>
          <template slot-scope="scope">
            {{ scope.row.accumulateYearOther ? scope.row.accumulateYearOther : '0' }}
          </template>
        </el-table-column>
        <el-table-column :label="year - 1 + '计划数'" width="65">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'plan_year_last')">
              {{ year - 1 }}计划数
              <!-- <span @click="updateDraftPlanSort(false,'plan_year_last')"><i class="el-icon-caret-top"></i></span>
              <span @click="updateDraftPlanSort(true,'plan_year_last')"><i class="el-icon-caret-bottom"></i></span> -->
            </div>
          </template>
          <template slot-scope="scope">
            {{ scope.row.planYearLast ? scope.row.planYearLast : '0' }}
          </template>
        </el-table-column>
        <el-table-column width="65">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'plan_year_this')">
              {{ year }}计划数
              <!-- <span @click="updateDraftPlanSort(false,'plan_year_this')"><i class="el-icon-caret-top"></i></span>
              <span @click="updateDraftPlanSort(true,'plan_year_this')"><i class="el-icon-caret-bottom"></i></span> -->
            </div>
          </template>
          <template slot-scope="scope">
            {{ scope.row.planYearThis ? scope.row.planYearThis : '0' }}
          </template>
        </el-table-column>
        <el-table-column label="计划增减" width="80">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'plan_diff')">
              计划增减
              <!-- <span @click="updateDraftPlanSort(false,'plan_diff')"><i class="el-icon-caret-top"></i></span>
              <span @click="updateDraftPlanSort(true,'plan_diff')"><i class="el-icon-caret-bottom"></i></span> -->
            </div>
          </template>
          <template slot-scope="scope">
            {{ scope.row.planDiff ? scope.row.planDiff : '0' }}
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序" width="80"></el-table-column>
<!--        <el-table-column label="排序" width="80">-->
<!--          <template slot-scope="scope">-->
<!--            <input size="small" @click.stop="kong($event)" v-model="scope.row.sort" disabled-->
<!--                   style="width: 26px;text-align:center;padding-left:10px;padding-right:10px"-->
<!--                   @blur="sortOptions(scope.row, scope.$index)"></input>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="操作" width="160">-->
<!--          <template slot-scope="scope">-->
<!--            <el-button style="font-size:14px;" type="text" @click.stop="addOptionsMarjor(scope.row)">添加专业-->
<!--            </el-button>-->
<!--            <el-button style="font-size:14px;" type="text" @click.stop="editOptionsMarjor(scope.row)">编辑</el-button>-->
<!--            <el-button type="text" style="color: #f56c6c;font-size:14px;" @click.stop="delOptions(scope.$index)">删除-->
<!--            </el-button>-->
<!--          </template>-->
<!--        </el-table-column>-->
      </el-table>
    </div>
    <!-- 院校专业志愿 -->
    <div class="table" v-if="(volunteerMode === 3 || volunteerMode === 1) && switchValue === 2">
      <el-table size="mini"  ref="majorTable" row-key="specialtyUuid" style="width: 100%" :max-height="tableHeigth"
                :row-class-name="tabRowClassName" :data="specialtyList" border :span-method="objectOneMethod"
                :header-cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
                :cell-style="{ 'text-align': 'center', 'font-size': '14px'}" >
        <el-table-column label="志愿" width="60">
          <template slot-scope="scope">
            {{ scope.row.sort }}
          </template>
        </el-table-column>
        <el-table-column prop="collegeCode" label="院校代码" width="100" v-if="volunteerMode === 1" key="collegeCode">
        </el-table-column>
        <el-table-column prop="collegeName" label="院校名称" :show-overflow-tooltip="true" min-width="120"
                         v-if="volunteerMode === 1"
                         key="collegeName"></el-table-column>
        <el-table-column prop="specialtyNames" label="专业组代码" v-if="volunteerMode === 3" width="100" key="specialtyNames">
        </el-table-column>
        <el-table-column prop="specialtyOptions" label="专业组名称" :show-overflow-tooltip="true" v-if="volunteerMode === 3"
                         key="specialtyOptions" min-width="150"></el-table-column>
        <el-table-column prop="collegeCharacter" label="特性" width="130" show-overflow-tooltip>
          <template slot-scope="scope">
<!--            <span v-if="scope.row.collegeCharacter &&-->
<!--              scope.row.collegeCharacter.includes('2')-->
<!--              ">985-->
<!--            </span>-->
<!--            <span v-if="scope.row.collegeCharacter &&-->
<!--              scope.row.collegeCharacter.includes('1')-->
<!--              ">211-->
<!--            </span>-->
<!--            <span v-if="scope.row.collegeCharacter &&-->
<!--              scope.row.collegeCharacter.includes('3')-->
<!--              ">双一流</span>-->
<!--            <span v-if="!scope.row.collegeCharacter">{{-->
<!--                matchRunType(scope.row.runType)-->
<!--              }}</span>-->
            <span v-if="scope.row.collegeTag">{{scope.row.collegeTag}}</span>
            <span v-if="scope.row.collegeTag && scope.row.collegeCharacter">&nbsp;&nbsp;</span>
            <span v-if="scope.row.collegeCharacter">{{scope.row.collegeCharacter}}</span>
          </template>
        </el-table-column>
        <el-table-column label="包含专业" min-width="120" show-overflow-tooltip v-if="volunteerMode === 3"
                         key="aspirationName">
          <template slot-scope="scope">
            {{ scope.row.aspirationName ? scope.row.aspirationName : "无" }}
          </template>
        </el-table-column>
        <el-table-column label="选考科目要求" min-width="150" show-overflow-tooltip v-if="volunteerMode === 3"
                         key="requiredType2">
          <template slot-scope="scope">
            <span>{{ matchRequiredType(scope.row.requiredType) }}</span>
            <span v-if="scope.row.requiredType !== 0">{{ scope.row.requiredDiscipline }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="scoreCollege" width="65">
          <template slot="header">
           <div @click="updateDraftPlanSort(true,'score_college')">
              {{year}}最低分
              <span @click="updateDraftPlanSort(false,'score_college')"><i class="el-icon-caret-top"></i></span>
              <span @click="updateDraftPlanSort(true,'score_college')"><i class="el-icon-caret-bottom"></i></span>
           </div>
          </template>
        </el-table-column> -->
        <el-table-column prop="scoreYearThis2" width="65" key="scoreYearThis2szy">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'score_year_this')">
              {{ admissionYear }}最低分
              <!-- <span @click="updateDraftPlanSort(false,'score_year_this')"><i class="el-icon-caret-top"></i></span>
              <span @click="updateDraftPlanSort(true,'score_year_this')"><i class="el-icon-caret-bottom"></i></span> -->
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="scoreYearLast" :label="year - 2 + '最低分'" width="65">
        </el-table-column> -->
        <el-table-column prop="accumulateYearThis2" width="68" key="accumulateYearThis2szy">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'accumulate_year_this')">
              {{ admissionYear }}最低位次
              <!-- <span @click="updateDraftPlanSort(false,'accumulate_year_this')"><i class="el-icon-caret-top"></i></span>
              <span @click="updateDraftPlanSort(true,'accumulate_year_this')"><i class="el-icon-caret-bottom"></i></span> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="accumulateYearLast2" width="68" key="accumulateYearLast2szy">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'accumulate_year_last')">
              {{ admissionYear - 1 }}最低位次
              <!-- <span @click="updateDraftPlanSort(false,'accumulate_year_last')"><i class="el-icon-caret-top"></i></span>
              <span @click="updateDraftPlanSort(true,'accumulate_year_last')"><i class="el-icon-caret-bottom"></i></span> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="accumulateYearOther2" width="68" key="accumulateYearOther2szy">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'accumulate_year_other')">
              {{ admissionYear - 2 }}最低位次
              <!-- <span @click="updateDraftPlanSort(false,'accumulate_year_other')"><i class="el-icon-caret-top"></i></span>
              <span @click="updateDraftPlanSort(true,'accumulate_year_other')"><i class="el-icon-caret-bottom"></i></span> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="planYearLast2" width="65" key="planYearLast2szy">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'plan_year_last')">
              {{ year - 1 }}计划数
              <!-- <span @click="updateDraftPlanSort(false,'plan_year_last')"><i class="el-icon-caret-top"></i></span>
              <span @click="updateDraftPlanSort(true,'plan_year_last')"><i class="el-icon-caret-bottom"></i></span> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="planYearThis2" width="65" key="planYearThis2szy">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'plan_year_this')">
              {{ year }}计划数
              <!-- <span @click="updateDraftPlanSort(false,'plan_year_this')"><i class="el-icon-caret-top"></i></span>
              <span @click="updateDraftPlanSort(true,'plan_year_this')"><i class="el-icon-caret-bottom"></i></span> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="planDiff2" width="80" key="planDiff2szy">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'plan_diff')">
              计划增减
              <!-- <span @click="updateDraftPlanSort(false,'plan_diff')"><i class="el-icon-caret-top"></i></span>
              <span @click="updateDraftPlanSort(true,'plan_diff')"><i class="el-icon-caret-bottom"></i></span> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="specialtyCode" label="专业代码" v-if="switchValue === 2" width="100" key="specialtyCode">
        </el-table-column>
        <el-table-column prop="specialtyName" label="专业名称" v-if="switchValue === 2" min-width="180"
                         :show-overflow-tooltip="true" key="specialtyName">
        </el-table-column>
        <!-- <el-table-column prop="scoreYearThis" width="65">
          <template slot="header">
           <div @click="updateDraftPlanSort(true,'score_year_this')">
              {{year}}最低分
              <span @click="updateDraftPlanSort(false,'score_year_this')"><i class="el-icon-caret-top"></i></span>
              <span @click="updateDraftPlanSort(true,'score_year_this')"><i class="el-icon-caret-bottom"></i></span>
           </div>
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="scoreYearLast" :label="year - 2 + '最低分'" width="65">
        </el-table-column> -->
        <el-table-column prop="accumulateYearThis" width="68" key="accumulateYearThisszy">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'accumulate_year_this')">
              {{ admissionYear }}最低位次
              <!-- <span @click="updateDraftPlanSort(false,'accumulate_year_this')"><i class="el-icon-caret-top"></i></span>
              <span @click="updateDraftPlanSort(true,'accumulate_year_this')"><i class="el-icon-caret-bottom"></i></span> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="accumulateYearLast" width="68" key="accumulateYearLastszy">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'accumulate_year_last')">
              {{ admissionYear - 1 }}最低位次
              <!-- <span @click="updateDraftPlanSort(false,'accumulate_year_last')"><i class="el-icon-caret-top"></i></span>
              <span @click="updateDraftPlanSort(true,'accumulate_year_last')"><i class="el-icon-caret-bottom"></i></span> -->
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="accumulateYearOther" width="68">
          <template slot="header">
           <div @click="updateDraftPlanSort(true,'accumulate_year_other')">
              {{year - 2}}最低位次
              <span @click="updateDraftPlanSort(false,'accumulate_year_other')"><i class="el-icon-caret-top"></i></span>
              <span @click="updateDraftPlanSort(true,'accumulate_year_other')"><i class="el-icon-caret-bottom"></i></span>
           </div>
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="planYearThis" width="65">
          <template slot="header">
           <div @click="updateDraftPlanSort(true,'plan_year_this')">
              {{nowyear}}计划数
              <span @click="updateDraftPlanSort(false,'plan_year_this')"><i class="el-icon-caret-top"></i></span>
              <span @click="updateDraftPlanSort(true,'plan_year_this')"><i class="el-icon-caret-bottom"></i></span>
           </div>
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="planYearLast" width="65">
          <template slot="header">
           <div @click="updateDraftPlanSort(true,'plan_year_last')">
              {{nowyear - 1}}计划数
              <span @click="updateDraftPlanSort(false,'plan_year_last')"><i class="el-icon-caret-top"></i></span>
              <span @click="updateDraftPlanSort(true,'plan_year_last')"><i class="el-icon-caret-bottom"></i></span>
           </div>
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="planDiff"  width="80">
          <template slot="header">
           <div @click="updateDraftPlanSort(true,'plan_diff')">
              计划增减
              <span @click="updateDraftPlanSort(false,'plan_diff')"><i class="el-icon-caret-top"></i></span>
              <span @click="updateDraftPlanSort(true,'plan_diff')"><i class="el-icon-caret-bottom"></i></span>
           </div>
          </template>
        </el-table-column> -->
        <el-table-column prop="psort" label="排序" width="80"></el-table-column>
<!--        <el-table-column label="排序" width="80">-->
<!--          <template slot-scope="scope">-->
<!--            <input size="small" @click.stop="kong($event)" v-if="scope.row.specialtyName" v-model="scope.row.psort" disabled-->
<!--                   @focus="getOldSort(scope.row.psort)" @blur="changesortSchoolspecialtyList(scope.row)"-->
<!--                   style="width: 26px;text-align:center;padding-left:10px;padding-right:10px"/>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="操作" width="60">-->
<!--          <template slot-scope="scope">-->
<!--            <el-button type="text" style="color: #f56c6c;font-size:14px;"-->
<!--                       @click.stop="delspecialtyList(scope.$index, true)" v-if="scope.row.specialtyName">删除-->
<!--            </el-button>-->
<!--          </template>-->
<!--        </el-table-column>-->
      </el-table>
    </div>
    <!-- 专业志愿 -->
    <div class="table" v-if="volunteerMode === 2 && switchValue === 2">
      <el-table size="mini" ref="majorTable" style="width: 100%" :data="specialtyList" :max-height="tableHeigth"
                :row-class-name="tableRowClassName" border row-key="specialtyUuid"
                :header-cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
                :cell-style="{ 'text-align': 'center', 'font-size': '14px'}"
      >
        <el-table-column prop="aspirationName" label="志愿" width="60">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="collegeCode" label="院校代码" width="100" key="collegeCodezy1"></el-table-column>
        <el-table-column prop="collegeName" label="院校名称" :show-overflow-tooltip="true" min-width="120"
                         key="collegeNamezy1"></el-table-column>
        <el-table-column prop="collegeCharacter" label="特性" width="130" show-overflow-tooltip>
          <template slot-scope="scope">
<!--            <span v-if="scope.row.collegeCharacter &&-->
<!--              scope.row.collegeCharacter.includes('2')-->
<!--              ">985-->
<!--            </span>-->
<!--            <span v-if="scope.row.collegeCharacter &&-->
<!--              scope.row.collegeCharacter.includes('1')-->
<!--              ">211-->
<!--            </span>-->
<!--            <span v-if="scope.row.collegeCharacter &&-->
<!--              scope.row.collegeCharacter.includes('3')-->
<!--              ">双一流</span>-->
<!--            <span v-if="!scope.row.collegeCharacter">{{-->
<!--                matchRunType(scope.row.runType)-->
<!--              }}</span>-->
            <span v-if="scope.row.collegeTag">{{scope.row.collegeTag}}</span>
            <span v-if="scope.row.collegeTag && scope.row.collegeCharacter">&nbsp;&nbsp;</span>
            <span v-if="scope.row.collegeCharacter">{{scope.row.collegeCharacter}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="scoreYearThis2" key="scoreCollegezy1">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'score_college')">
              {{ admissionYear }}最低分
              <!-- <span @click="updateDraftPlanSort(true,'score_college')"><i class="el-icon-caret-top"></i></span>
              <span @click="updateDraftPlanSort(false,'score_college')"><i class="el-icon-caret-bottom"></i></span> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="specialtyCode" label="专业代码" v-if="switchValue === 2" width="100"
                         key="specialtyCode1">
        </el-table-column>
        <el-table-column prop="specialtyName" label="专业名称" v-if="switchValue === 2" min-width="180"
                         :show-overflow-tooltip="true" key="specialtyName1">
        </el-table-column>
        <el-table-column label="选考科目要求" min-width="150" show-overflow-tooltip v-if="volunteerMode !== 1"
                         key="requiredType1">
          <template slot-scope="scope">
            <span>{{ matchRequiredType(scope.row.requiredType) }}</span>
            <span v-if="scope.row.requiredType !== 0">{{ scope.row.requiredDiscipline }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="scoreYearThis" key="scoreYearThiszy1">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'score_year_this')">
              {{ admissionYear }}最低分
              <!-- <span @click="updateDraftPlanSort(false,'score_year_this')"><i class="el-icon-caret-top"></i></span>
              <span @click="updateDraftPlanSort(true,'score_year_this')"><i class="el-icon-caret-bottom"></i></span> -->
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="scoreYearLast" :label="year - 2 + '最低分'" width="65">
        </el-table-column> -->
        <el-table-column prop="accumulateYearThis" width="68" key="accumulateYearThiszy1">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'accumulate_year_this')">
              {{ admissionYear }}最低位次
              <!-- <span @click="updateDraftPlanSort(false,'accumulate_year_this')"><i class="el-icon-caret-top"></i></span>
              <span><i class="el-icon-caret-bottom" @click="updateDraftPlanSort(true,'accumulate_year_this')"></i></span> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="accumulateYearLast" width="68" key="accumulateYearLastzy1">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'accumulate_year_last')">
              {{ admissionYear - 1 }}最低位次
              <!-- <span @click="updateDraftPlanSort(false,'accumulate_year_last')"><i class="el-icon-caret-top"></i></span>
              <span @click="updateDraftPlanSort(true,'accumulate_year_last')"><i class="el-icon-caret-bottom"></i></span> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="accumulateYearOther" width="68" key="accumulateYearOtherzy1">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'accumulate_year_other')">
              {{ admissionYear - 2 }}最低位次
              <!-- <span @click="updateDraftPlanSort(false,'accumulate_year_other')"><i class="el-icon-caret-top"></i></span>
              <span @click="updateDraftPlanSort(true,'accumulate_year_other')"><i class="el-icon-caret-bottom"></i></span> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="planYearLast" width="65" key="planYearThiszy1">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'plan_year_last')">
              {{ year - 1 }}计划数
              <!-- <span @click="updateDraftPlanSort(false,'plan_year_last')"><i class="el-icon-caret-top"></i></span>
              <span @click="updateDraftPlanSort(true,'plan_year_last')"><i class="el-icon-caret-bottom"></i></span> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="planYearThis" width="65" key="planYearLastzy1">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'plan_year_this')">
              {{ year }}计划数
              <!-- <span @click="updateDraftPlanSort(false,'plan_year_this')"><i class="el-icon-caret-top"></i></span>
              <span @click="updateDraftPlanSort(true,'plan_year_this')"><i class="el-icon-caret-bottom"></i></span> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="planDiff" width="80" key="planDiffzy1">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'plan_diff')">
              计划增减
              <!-- <span @click="updateDraftPlanSort(false,'plan_diff')"><i class="el-icon-caret-top"></i></span>
              <span @click="updateDraftPlanSort(true,'plan_diff')"><i class="el-icon-caret-bottom"></i></span> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="psort" label="排序" width="80"></el-table-column>
<!--        <el-table-column label="排序" width="80">-->
<!--          <template slot-scope="scope">-->
<!--            <input size="small" v-model="scope.row.psort" @click.stop="kong($event)" disabled-->
<!--                   @blur="changesortspecialtyList(scope.row, scope.$index)"-->
<!--                   style="width: 26px;text-align:center;padding-left:10px;padding-right:10px"></input>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="操作" width="60">-->
<!--          <template slot-scope="scope">-->
<!--            <el-button type="text" style="color: #f56c6c;font-size:14px;"-->
<!--                       @click.stop="delspecialtyList(scope.$index, false)">删除-->
<!--            </el-button>-->
<!--          </template>-->
<!--        </el-table-column>-->
      </el-table>
    </div>
    <div style="margin-top:10px" v-if="switchValue === 1">共{{
        collegeList ? collegeList.length : 0
      }}所学校，{{ specialtyList.length }}个专业
    </div>
    <div style="margin-top:10px" v-if="switchValue === 3">共{{
        optionsList.length
      }}个专业组，{{ specialtyList.length }}个专业
    </div>
    <div style="margin-top:10px" v-if="switchValue === 2">共{{ specialtyList.length }}个专业</div>
  </div>
</template>

<script>
import Sortable from "sortablejs";
import lpyMixin from "@/mixin/lpyMixin";

export default {
  mixins: [lpyMixin],
  components: {
    Sortable,
  },
  props: {
    idOne: {
      type: String,
      default: "",
    },
    draftform: {
      type: Array,
      default: () => [],
    },
    activeName: {
      type: String,
      default: "",
    },
    voPa: {
      type: Number,
      default: 0,
    },
    id: {
      type: String,
      default: "",
    },
    year: {
      type: Number,
      default: new Date().getFullYear(),
    },
    admissionYear: {
      type: Number,
      default: new Date().getFullYear() - 1,
    },
  },
  data() {
    return {
      volunteerMode: 0,
      switchValue: 2,
      tableHeightSubtract: 200,
      collegeList: [], //院校志愿
      specialtyList: [], //专业志愿
      optionsList: [], //专业组志愿
      spanArr: [],
      pos: 0,
      oldSOrt: 0,
      fatherSort: 0,
      order: null,
      row: {},
      draftId: "",
      chooseSchoolList: [],
      chooseOptionsList: [],
      chooseSpecialtyList: [],
      chooseSpecialtyList1: [],
    };
  },
  watch: {
    voPa: {
      immediate: true, //绑定值就开始执行监听，而不是等值改变。
      handler(newValue, oldValue) {
        this.volunteerMode = newValue;
        this.changeswitch(); //this.volunteerMode
      },
      deep: true,
    },
    id: {
      immediate: true, //绑定值就开始执行监听，而不是等值改变。
      handler(newValue, oldValue) {
        this.draftId = newValue;
      },
      deep: true,
    },
  },
  mounted() {},
  created() {},
  methods: {
    matchRequiredType(requiredType) {
      switch (requiredType) {
        case 0:
          return "不提科目要求";
        case 1:
          return "任选一门报考：";
        case 2:
          return "均报考：";
      }
    },
    updateDraftPlanSort(asc, column) {
      // updateDraftPlanSort({
      //   admitBatch: this.activeName,
      //   dataType: this.switchValue,
      //   voPa: this.volunteerMode,
      //   draftId: this.draftId,
      //   orderItem: { asc: asc, column: column },
      // }).then((res) => {
      //   if (res.code === 1) {
      //     this.$emit("getDraftList", this.idOne);
      //   }
      // });
    },
    schoolSort() {
      this.specialtyList = [];
      this.collegeList.forEach((item) => {
        if (item.specialtyList) {
          this.specialtyList.push(...item.specialtyList);
        }
      });
      this.specialtyList.forEach((item, index) => {
        item.psort = index + 1;
      });
      this.$emit("specialtyListSort", this.specialtyList);
    },
    marjorSort() {
      this.specialtyList.sort(function (c, d) {
        return d.scoreYearThis - c.scoreYearThis;
      });
      this.specialtyList.forEach((item, index) => {
        item.psort = index + 1;
      });
      this.$emit("specialtyListSort", this.specialtyList);
    },
    addOptionsMarjor(data) {
      this.$emit("addOptionsMarjor", data);
    },
    // 批量删除
    del() {
      if (this.switchValue === 1) {
        if (this.chooseSchoolList.length < 1) {
          this.$message({
            message: "请先选择删除院校",
            type: "warning",
          });
          return;
        }
      }
      if (this.switchValue === 2) {
        if (this.chooseSpecialtyList.length < 1) {
          this.$message({
            message: "请先选择删除专业",
            type: "warning",
          });
          return;
        }
      }
      if (this.switchValue === 3) {
        if (this.chooseOptionsList.length < 1) {
          this.$message({
            message: "请先选择删除专业组",
            type: "warning",
          });
          return;
        }
      }
      this.$confirm("是否确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        if (this.switchValue === 1) {
          console.log("院校");
          // 院校
          this.collegeList = this.collegeList.filter((item) => {
            return this.chooseSchoolList.indexOf(item.specialtyUuid) === -1;
          });
          let zyData = [];
          let zyzData = [];
          for (let i = 0; i < this.collegeList.length; i++) {
            this.collegeList[i].sort = i + 1;
            if (this.volunteerMode === 2) {
              if (
                this.collegeList[i].specialtyList &&
                this.collegeList[i].specialtyList.length > 0
              ) {
                zyData = [...zyData, ...this.collegeList[i].specialtyList];
              }
            }
            if (this.volunteerMode === 3) {
              if (
                this.collegeList[i].optionsList &&
                this.collegeList[i].optionsList.length > 0
              ) {
                zyzData = [...zyzData, ...this.collegeList[i].optionsList];
              }
            }
            if (this.volunteerMode === 1) {
              if (
                this.collegeList[i].specialtyList &&
                this.collegeList[i].specialtyList.length > 0
              ) {
                this.collegeList[i].specialtyList.forEach((item) => {
                  item.sort = i + 1;
                });
              }
            }
          }
          if (this.volunteerMode === 3) {
            // zyzData.sort(function (c, d) {
            //   return d.scoreYearThis - c.scoreYearThis;
            // });
            zyzData.forEach((item, i) => {
              item.sort = i + 1;
              if (item.optionsList && item.optionsList.length > 0) {
                item.optionsList.forEach((itemspe) => {
                  itemspe.sort = i + 1;
                });
              }
            });
            this.collegeList.forEach((item) => {
              item.optionsList = [];
              zyzData.forEach((zyzitem, i) => {
                if (
                  item.collegeName === zyzitem.collegeName &&
                  item.specialtyOptions === zyzitem.specialtyOptions
                ) {
                  item.optionsList.push(zyzitem);
                }
              });
            });
          }
          if (this.volunteerMode === 2) {
            zyData.sort(function (c, d) {
              return d.scoreYearThis - c.scoreYearThis;
            });
            zyData.forEach((item, i) => {
              item.psort = i + 1;
            });
            this.collegeList.forEach((item) => {
              item.specialtyList = [];
              zyData.forEach((zyitem, i) => {
                if (
                  item.collegeName === zyitem.collegeName &&
                  item.specialtyOptions === zyitem.specialtyOptions
                ) {
                  item.specialtyList.push(zyitem);
                }
              });
            });
          }
          this.resetSpecialtyList();
          this.$emit("collegeList", this.collegeList);
        }
        if (this.switchValue === 2) {
          console.log("专业");
          // 专业
          // 专业模式
          if (this.volunteerMode === 2) {
            console.log("专业专业批量删除");
            // this.chooseSpecialtyList.forEach((chooseSpe) => {
            //   if (!chooseSpe.specialtyName) {
            //     this.collegeList.forEach((sch, ind) => {
            //       if (sch.collegeName === chooseSpe.collegeName) {
            //         this.collegeList.splice(ind, 1);
            //         for (let i = ind; i < this.collegeList.length; i++) {
            //           this.collegeList[i].sort = this.collegeList[i].sort - 1;
            //         }
            //       }
            //     });
            //   }
            // });
            this.specialtyList.forEach((spe, n) => {
              this.chooseSpecialtyList.forEach((chooseSpe) => {
                if (chooseSpe.specialtyName) {
                  if (
                    spe.collegeName === chooseSpe.collegeName &&
                    spe.specialtyName === chooseSpe.specialtyName
                  ) {
                    this.specialtyList.splice(n, 1);
                  }
                } else {
                  this.collegeList.forEach((sch, ind) => {
                    if (sch.collegeName === chooseSpe.collegeName) {
                      this.collegeList.splice(ind, 1);
                      for (let i = ind; i < this.collegeList.length; i++) {
                        this.collegeList[i].sort = this.collegeList[i].sort - 1;
                      }
                    }
                  });
                }
              });
            });

            this.specialtyList = this.specialtyList.filter((item) => {
              return (
                this.chooseSpecialtyList1.indexOf(item.specialtyUuid) === -1
              );
            });
            for (let i = 0; i < this.specialtyList.length; i++) {
              this.specialtyList[i].psort = i + 1;
            }
            this.collegeList.forEach((college) => {
              college.specialtyList = [];
              if (this.specialtyList && this.specialtyList.length > 0) {
                this.specialtyList.forEach((marjor) => {
                  if (
                    marjor.collegeName === college.collegeName &&
                    marjor.specialtyOptions === college.specialtyOptions
                    // && marjor.specialtyName
                  ) {
                    college.specialtyList.push(marjor);
                  }
                });
              }
            });
            this.$emit("collegeList", this.collegeList);
          } else {
            // chooseSpecialtyList 选择专业数组
            // 专业组模式
            if (this.volunteerMode === 3) {
              console.log("专业 - 专业组模式");
              this.collegeList.forEach((school, index) => {
                this.chooseSpecialtyList.forEach((row) => {
                  if (school.collegeName === row.collegeName) {
                    if (school.optionsList && school.optionsList.length > 0) {
                      school.optionsList.forEach((options, i) => {
                        if (
                          options.collegeName === row.collegeName &&
                          options.specialtyOptions === row.specialtyOptions
                        ) {
                          this.collegeList[index].optionsList.splice(i, 1);
                          // options.specialtyList.splice(row.psort - 1, 1);
                          // options.specialtyList.sort(function (a, b) {
                          //   return a.psort - b.psort;
                          // });
                          // options.specialtyList.forEach((marjor, ind) => {
                          //   marjor.psort = ind + 1;
                          // });
                        }
                      });
                    }
                  }
                });
              });
              this.specialtyList = [];
              this.optionsList = [];
              this.collegeList.forEach((college) => {
                if (college.optionsList && college.optionsList.length > 0) {
                  this.optionsList = [
                    ...this.optionsList,
                    ...college.optionsList,
                  ];
                  college.optionsList.forEach((option) => {
                    if (option.specialtyList) {
                      this.specialtyList = [
                        ...this.specialtyList,
                        ...option.specialtyList,
                      ];
                    }
                  });
                }
              });
              this.optionsList.sort(function (a, b) {
                return a.sort - b.sort;
              });
              for (let i = 0; i < this.optionsList.length; i++) {
                this.optionsList[i].sort = i + 1;
              }
              console.log(this.optionsList, "this.optionsList");
              this.$emit("getOptions", this.optionsList);
            }
            // 院校模式
            if (this.volunteerMode === 1) {
              console.log("专业院校批量删除");
              this.collegeList.forEach((school, index) => {
                this.chooseSpecialtyList.forEach((row) => {
                  if (
                    school.collegeName === row.collegeName &&
                    school.collegeCode === row.collegeCode
                  ) {
                    this.collegeList.splice(index, 1);
                  }
                });
              });
              this.specialtyList = [];
              this.collegeList.forEach((college, i) => {
                college.sort = i + 1;
                if (college.specialtyList && college.specialtyList.length > 0) {
                  college.specialtyList.forEach((item) => {
                    item.sort = college.sort;
                  });
                  this.specialtyList = [
                    ...this.specialtyList,
                    ...college.specialtyList,
                  ];
                }
              });
              this.$emit("collegeList", this.collegeList);
              this.changeswitch();
            }
          }
        }
        if (this.switchValue === 3) {
          console.log("专业组");
          // 专业组
          this.optionsList = this.optionsList.filter((item) => {
            return this.chooseOptionsList.indexOf(item.specialtyUuid) === -1;
          });
          for (let i = 0; i < this.optionsList.length; i++) {
            this.optionsList[i].sort = i + 1;
          }
          this.specialtyList = [];
          for (let i = 0; i < this.optionsList.length; i++) {
            this.specialtyList = [
              ...this.specialtyList,
              ...this.optionsList[i].specialtyList,
            ];
          }
          this.$emit("getOptions", this.optionsList);
        }
      });
    },
    kong(e) {
      e.currentTarget.select();
    },
    // 选择批量删除院校志愿
    handleSelectionSchoolChange(val) {
      this.chooseSchoolList = [];
      val.forEach((item) => {
        this.chooseSchoolList.push(item.specialtyUuid);
      });
      console.log(this.chooseSchoolList, "this.chooseSchoolList");
    },
    handleRowSelectionChangeschool(row, col, event) {
      row.flag = !row.flag;
      let volunteerMode = null;
      let isHaveItem = this.chooseSchoolList.find(
        (item) => row.specialtyUuid === item
      );
      if (isHaveItem) {
        volunteerMode = false;
        this.chooseSchoolList = this.chooseSchoolList.filter(
          (item) => isHaveItem !== item
        );
      } else {
        volunteerMode = true;
        this.chooseSchoolList.push(row.specialtyUuid);
      }
      this.$refs.schoolTable.toggleRowSelection(row, volunteerMode);
      console.log([...this.chooseSchoolList], "选择1");
    },
    handleSelectionOptionsChange(val) {
      this.chooseOptionsList = [];
      val.forEach((item) => {
        this.chooseOptionsList.push(item.specialtyUuid);
      });
    },
    handleRowSelectionChangeOptions(row, col, event) {
      row.flag = !row.flag;
      let volunteerMode = null;
      let isHaveItem = this.chooseOptionsList.find(
        (item) => row.specialtyUuid === item
      );
      if (isHaveItem) {
        volunteerMode = false;
        this.chooseOptionsList = this.chooseOptionsList.filter(
          (item) => isHaveItem !== item
        );
      } else {
        volunteerMode = true;
        this.chooseOptionsList.push(row.specialtyUuid);
      }
      this.$refs.optionsTable.toggleRowSelection(row, volunteerMode);
    },
    handleSelectionMajorChange(val) {
      console.log([...val], "专业");
      this.chooseSpecialtyList = val;
      this.chooseSpecialtyList1 = [];
      val.forEach((item) => {
        this.chooseSpecialtyList1.push(item.specialtyUuid);
      });
    },
    handleRowSelectionChangeMajor(row, col, event) {
      row.flag = !row.flag;
      let volunteerMode = null;
      let isHaveItem = this.chooseSpecialtyList1.find(
        (item) => row.specialtyUuid === item
      );
      if (isHaveItem) {
        volunteerMode = false;
        this.chooseSpecialtyList1 = this.chooseSpecialtyList1.filter(
          (item) => isHaveItem !== item
        );
      } else {
        volunteerMode = true;
        this.chooseSpecialtyList1.push(row.specialtyUuid);
      }
      this.$refs.majorTable.toggleRowSelection(row, volunteerMode);
    },
    exportTemplate(type) {
      this.$emit("exportTemplate", type);
    },
    preview() {
      this.$emit("preview");
    },
    editOptionsMarjor(data) {
      this.$emit("editOptionsMarjor", data);
    },
    delOptions(index) {
      console.log("删除志愿");
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.optionsList.splice(index, 1);
        for (let i = index; i < this.optionsList.length; i++) {
          this.optionsList[i].sort = this.optionsList[i].sort - 1;
        }
        this.specialtyList = [];
        for (let i = 0; i < this.optionsList.length; i++) {
          this.specialtyList = [
            ...this.specialtyList,
            ...this.optionsList[i].specialtyList,
          ];
        }
        this.$emit("getOptions", this.optionsList);
      });
    },
    addMajorVolunteerClick() {
      this.$emit("addMajorVolunteerClick");
    },
    addVolunteerOptionsClick(type, data) {
      this.$emit("addVolunteerOptionsClick", { type: type, data: data });
    },
    addVolunteerClick() {
      this.$emit("addVolunteerClick");
    },
    // 高校拖动
    rowDrop() {
      // if (this.switchValue !== 2 || this.volunteerMode === 2) {
      const tbody = document.querySelector(".el-table__body-wrapper tbody");
      const _this = this;
      if (tbody) {
        var sortable = Sortable.create(tbody, {
          animation: 100,
          onEnd({ oldIndex, newIndex }) {
            console.log(
              _this.volunteerMode,
              _this.switchValue,
              "_this.volunteerMode,_this.switchValue"
            );

            console.log("旧下标" + oldIndex);
            console.log("新下标" + newIndex);
            if (_this.switchValue === 1) {
              console.log("666");

              // _this.collegeList = _this.computeSort(
              //   oldIndex,
              //   newIndex,
              //   _this.collegeList,
              //   1
              // );

              let data = { ..._this.collegeList[oldIndex] };
              data.sort = newIndex + 1;

              if (data.sort < oldIndex + 1) {
                // 大于等于newSort 小于oldSort的sort+1
                _this.collegeList.forEach((item) => {
                  let tempSort = parseInt(item.sort);
                  if (
                    item.specialtyUuid !== data.specialtyUuid &&
                    item.sort >= data.sort &&
                    item.sort < oldIndex + 1
                  ) {
                    item.sort = tempSort + 1;
                  }
                  if (item.specialtyUuid === data.specialtyUuid) {
                    item.sort = data.sort;
                  }
                });
              }

              if (data.sort > oldIndex) {
                //小于等于newSort 大于oldSort 的sort - 1
                _this.collegeList.forEach((item) => {
                  let tempSort = parseInt(item.sort);
                  if (
                    item.specialtyUuid !== data.specialtyUuid &&
                    item.sort > oldIndex + 1 &&
                    item.sort <= data.sort
                  ) {
                    item.sort = tempSort - 1;
                  }
                  if (item.specialtyUuid === data.specialtyUuid) {
                    item.sort = data.sort;
                  }
                });
              }
              _this.collegeList.sort(function (a, b) {
                return a.sort - b.sort;
              });

              for (let i = 0; i < _this.collegeList.length; i++) {
                if (_this.volunteerMode === 1) {
                  if (_this.collegeList[i].specialtyList) {
                    _this.collegeList[i].specialtyList.forEach((specialty) => {
                      specialty.sort = i + 1;
                    });
                  }
                }
              }

              _this.$emit("collegeList", _this.collegeList);
            } else if (_this.switchValue === 2) {
              console.log("555");
              if (_this.volunteerMode === 2) {
                console.log("444");

                // _this.specialtyList = _this.computeSort(
                //   oldIndex,
                //   newIndex,
                //   _this.specialtyList,
                //   0
                // );

                //原sort  index
                //现sort  data.psort
                let data = { ..._this.specialtyList[oldIndex] };
                data.psort = newIndex + 1;

                if (data.psort < oldIndex + 1) {
                  // 大于等于newSort 小于oldSort的sort+1
                  _this.specialtyList.forEach((item) => {
                    let tempSort = parseInt(item.psort);
                    if (
                      item.specialtyUuid !== data.specialtyUuid &&
                      item.psort >= data.psort &&
                      item.psort < oldIndex + 1
                    ) {
                      item.psort = tempSort + 1;
                    }
                    if (item.specialtyUuid === data.specialtyUuid) {
                      item.psort = data.psort;
                    }
                  });
                }

                if (data.psort > oldIndex) {
                  //小于等于newSort 大于oldSort 的sort - 1
                  _this.specialtyList.forEach((item) => {
                    let tempSort = parseInt(item.psort);
                    if (
                      item.specialtyUuid !== data.specialtyUuid &&
                      item.psort > oldIndex + 1 &&
                      item.psort <= data.psort
                    ) {
                      item.psort = tempSort - 1;
                    }
                    if (item.specialtyUuid === data.specialtyUuid) {
                      item.psort = data.psort;
                    }
                  });
                }
                _this.specialtyList.sort(function (a, b) {
                  return a.psort - b.psort;
                });

                _this.$emit("delspecialtyList", _this.specialtyList);
              } else {
                if (
                  _this.specialtyList[oldIndex].collegeName !==
                    _this.specialtyList[newIndex].collegeName ||
                  _this.specialtyList[oldIndex].specialtyOptions !==
                    _this.specialtyList[newIndex].specialtyOptions
                ) {
                  console.log("不在同一个学校或专业组");
                  // 暴力重新渲染！
                  let volunteerMode = _this.volunteerMode;
                  _this.volunteerMode = 999;
                  console.log(_this.volunteerMode, "_this.volunteerMode");
                  // 借助nextTick和v-if重新渲染
                  _this.$nextTick(function () {
                    _this.volunteerMode = volunteerMode;
                    _this.$nextTick(function () {
                      // 重新渲染之后，重新进行Sortable绑定
                      // _this.rowDrop();
                      _this.setrowspans();
                    });
                  });
                } else {
                  if (_this.volunteerMode === 1) {
                    console.log("111111111");
                    _this.specialtyList = _this.computeShoolMarjorSort(
                      oldIndex,
                      newIndex,
                      _this.specialtyList
                    );
                  }
                  if (_this.volunteerMode === 3) {
                    _this.specialtyList = _this.computeShoolMarjoroptionsSort(
                      oldIndex,
                      newIndex,
                      _this.specialtyList
                    );
                  }
                }
                console.log("重新计算合并");
                _this.setrowspans();
              }
            } else {
              console.log("111");
              // _this.optionsList = _this.computeSort(
              //   oldIndex,
              //   newIndex,
              //   _this.optionsList,
              //   1
              // );

              let data = { ..._this.optionsList[oldIndex] };
              data.sort = newIndex + 1;

              if (data.sort < oldIndex + 1) {
                // 大于等于newSort 小于oldSort的sort+1
                _this.optionsList.forEach((item) => {
                  let tempSort = parseInt(item.sort);
                  if (
                    item.specialtyUuid !== data.specialtyUuid &&
                    item.sort >= data.sort &&
                    item.sort < oldIndex + 1
                  ) {
                    item.sort = tempSort + 1;
                  }
                  if (item.specialtyUuid === data.specialtyUuid) {
                    item.sort = data.sort;
                  }
                });
              }

              if (data.sort > oldIndex) {
                //小于等于newSort 大于oldSort 的sort - 1
                _this.optionsList.forEach((item) => {
                  let tempSort = parseInt(item.sort);
                  if (
                    item.specialtyUuid !== data.specialtyUuid &&
                    item.sort > oldIndex + 1 &&
                    item.sort <= data.sort
                  ) {
                    item.sort = tempSort - 1;
                  }
                  if (item.specialtyUuid === data.specialtyUuid) {
                    item.sort = data.sort;
                  }
                });
              }
              _this.optionsList.sort(function (a, b) {
                return a.sort - b.sort;
              });

              for (let i = 0; i < _this.optionsList.length; i++) {
                if (_this.volunteerMode === 1) {
                  if (_this.optionsList[i].specialtyList) {
                    _this.optionsList[i].specialtyList.forEach((specialty) => {
                      specialty.sort = i + 1;
                    });
                  }
                }
              }

              _this.$emit("getOptions", _this.optionsList);
            }
          },
        });
      }
      // }
    },
    computeSort(oldIndex, newIndex, oldList, isSchool) {
      console.log([...oldList], "oldList");
      if (oldIndex === newIndex) {
        return oldList;
      }
      let data = oldList[oldIndex];
      if (newIndex > oldIndex) {
        oldList.splice(newIndex + 1, 0, data);
        oldList.splice(oldIndex, 1);
      } else {
        oldList.splice(newIndex, 0, data);
        oldList.splice(oldIndex + 1, 1);
      }
      for (let i = 0; i < oldList.length; i++) {
        if (isSchool) {
          oldList[i].sort = i + 1;
          if (this.volunteerMode === 1) {
            if (oldList[i].specialtyList) {
              oldList[i].specialtyList.forEach((specialty) => {
                specialty.sort = i + 1;
              });
            }
          }
        } else {
          oldList[i].psort = i + 1;
        }
      }
      console.log([...oldList], "新数组");
      if (this.switchValue === 1) {
        this.$emit("collegeList", oldList);
      } else if (this.switchValue === 2) {
        this.$emit("delspecialtyList", oldList);
      } else {
        this.$emit("getOptions", oldList);
      }
      return oldList;
    },
    computeShoolMarjorSort(oldIndex, newIndex, oldList) {
      // let row = oldList[oldIndex];
      // let newrrow = oldList[newIndex];

      let data = { ...oldList[oldIndex] };
      let oldSort = data.psort;
      data.psort = oldList[newIndex].psort;

      this.collegeList.forEach((school) => {
        if (
          school.collegeName === data.collegeName &&
          school.specialtyOptions === data.specialtyOptions
        ) {
          // if (oldIndex === newIndex) {
          //   return oldList;
          // }
          // if (newIndex > oldIndex) {
          //   console.log("下拉");
          //   school.specialtyList.splice(newrrow.psort, 0, row);
          //   school.specialtyList.splice(row.psort - 1, 1);
          // } else {
          //   console.log("上拉");
          //   school.specialtyList.splice(newrrow.psort - 1, 0, row);
          //   school.specialtyList.splice(row.psort, 1);
          // }
          // for (let i = 0; i < school.specialtyList.length; i++) {
          //   school.specialtyList[i].psort = i + 1;
          // }

          school.specialtyList.forEach((item) => {
            if (item.specialtyUuid === data.specialtyUuid) {
              item.psort = data.psort;
            }
          });
          if (data.psort < oldSort) {
            // 大于等于newSort 小于oldSort的sort+1
            school.specialtyList.forEach((item) => {
              let tempSort = parseInt(item.psort);
              if (
                item.specialtyUuid !== data.specialtyUuid &&
                item.psort >= data.psort &&
                item.psort < oldSort
              ) {
                item.psort = tempSort + 1;
              }
            });
          }

          if (data.psort > oldSort) {
            //小于等于newSort 大于oldSort 的sort - 1
            school.specialtyList.forEach((item) => {
              let tempSort = parseInt(item.psort);
              if (
                item.specialtyUuid !== data.specialtyUuid &&
                item.psort > oldSort &&
                item.psort <= data.psort
              ) {
                item.psort = tempSort - 1;
              }
            });
          }
          school.specialtyList.sort(function (a, b) {
            return a.psort - b.psort;
          });
        }
      });

      oldList = [];
      this.collegeList.forEach((college) => {
        if (college.specialtyList) {
          oldList = [...oldList, ...college.specialtyList];
        }
      });
      this.$emit("collegeList", this.collegeList);
      // this.$emit("delspecialtyList", oldList);
      console.log(oldList, "oldlist12345");
      return oldList;
    },
    computeShoolMarjoroptionsSort(oldIndex, newIndex, oldList) {
      // let row = oldList[oldIndex];
      // let newrrow = oldList[newIndex];
      let data = { ...oldList[oldIndex] };
      let oldPSort = data.psort;
      data.psort = oldList[newIndex].psort;
      this.collegeList.forEach((school) => {
        if (school.collegeName === data.collegeName) {
          if (school.optionsList && school.optionsList.length > 0) {
            school.optionsList.forEach((option) => {
              if (
                option.collegeName === data.collegeName &&
                option.specialtyOptions === data.specialtyOptions
              ) {
                // if (oldIndex === newIndex) {
                //   return oldList;
                // }
                // if (newIndex > oldIndex) {
                //   console.log("下拉");
                //   option.specialtyList.splice(newrrow.psort, 0, row);
                //   option.specialtyList.splice(row.psort - 1, 1);
                // } else {
                //   console.log("上拉");
                //   option.specialtyList.splice(newrrow.psort - 1, 0, row);
                //   option.specialtyList.splice(row.psort, 1);
                // }
                // for (let i = 0; i < option.specialtyList.length; i++) {
                //   option.specialtyList[i].psort = i + 1;
                // }

                option.specialtyList.forEach((item) => {
                  if (item.specialtyUuid === data.specialtyUuid) {
                    item.psort = data.psort;
                  }
                });
                if (data.psort < oldPSort) {
                  // 大于等于newSort 小于oldSort的sort+1
                  option.specialtyList.forEach((item) => {
                    let tempSort = parseInt(item.psort);
                    if (
                      item.specialtyUuid !== data.specialtyUuid &&
                      item.psort >= data.psort &&
                      item.psort < oldPSort
                    ) {
                      item.psort = tempSort + 1;
                    }
                  });
                }

                if (data.psort > oldPSort) {
                  //小于等于newSort 大于oldSort 的sort - 1
                  option.specialtyList.forEach((item) => {
                    let tempSort = parseInt(item.psort);
                    if (
                      item.specialtyUuid !== data.specialtyUuid &&
                      item.psort > oldPSort &&
                      item.psort <= data.psort
                    ) {
                      item.psort = tempSort - 1;
                    }
                  });
                }
                option.specialtyList.sort(function (a, b) {
                  return a.psort - b.psort;
                });
              }
            });
          }
        }
      });
      oldList = [];
      this.collegeList.forEach((college) => {
        if (college.optionsList && college.optionsList.length > 0) {
          college.optionsList.forEach((op) => {
            if (op.specialtyList) {
              oldList = [...oldList, ...op.specialtyList];
            }
          });
        }
      });
      console.log([...oldList], "oldList111222");

      this.$emit("collegeList", this.collegeList);
      // this.$emit("delspecialtyList", oldList);
      return oldList;
    },
    // 专业组排序
    sortOptions(row, index) {
      // let data = this.optionsList[index];
      // console.log(data, index);
      // if (data.sort > this.optionsList.length) {
      //   data.sort = this.optionsList.length;
      // }
      // let sort = index + 1 + "";
      // if (data.sort < 0 || data.sort - 0 === NaN) {
      //   data.sort = sort;
      // }
      // if (data.sort === sort) {
      //   return;
      // }
      // if (data.sort > sort) {
      //   this.optionsList.splice(data.sort, 0, data);
      //   this.optionsList.splice(index, 1);
      // } else {
      //   this.optionsList.splice(data.sort - 1, 0, data);
      //   this.optionsList.splice(index + 1, 1);
      // }
      // for (let i = 0; i < this.optionsList.length; i++) {
      //   this.optionsList[i].sort = i + 1;
      // }

      let oldIndex = index + 1;
      let data = { ...row };
      if (data.sort < 1) {
        data.sort = 1;
      }
      if (data.sort > this.optionsList.length) {
        data.sort = this.optionsList.length;
      }
      if (data.sort < oldIndex) {
        // 大于等于newSort 小于oldSort的sort+1
        this.optionsList.forEach((item) => {
          let tempSort = parseInt(item.sort);
          if (
            item.specialtyUuid !== data.specialtyUuid &&
            item.sort >= data.sort &&
            item.sort < oldIndex
          ) {
            item.sort = tempSort + 1;
          }
          if (item.specialtyUuid === data.specialtyUuid) {
            item.sort = data.sort;
          }
        });
      }
      if (data.sort > oldIndex) {
        //小于等于newSort 大于oldSort 的sort - 1
        this.optionsList.forEach((item) => {
          let tempSort = parseInt(item.sort);
          if (
            item.specialtyUuid !== data.specialtyUuid &&
            item.sort > oldIndex &&
            item.sort <= data.sort
          ) {
            item.sort = tempSort - 1;
          }
          if (item.specialtyUuid === data.specialtyUuid) {
            item.sort = data.sort;
          }
        });
      }
      this.optionsList.sort(function (a, b) {
        return a.sort - b.sort;
      });

      this.$emit("getOptions", this.optionsList);
    },
    changeFatherSort(data) {
      if (this.volunteerMode === 1) {
        let sort = this.fatherSort;
        let row = this.collegeList[sort - 1];
        console.log(row, "改变院校");
        if (data.sort < 0 || data.sort - 0 === NaN) {
          data.sort = sort;
        }
        if (data.sort === sort) {
          return;
        }
        if (data.sort > this.collegeList.length) {
          data.sort = this.collegeList.length;
        }
        console.log([...this.collegeList], "院校");
        if (data.sort > sort) {
          this.collegeList.splice(data.sort, 0, { ...row });
          this.collegeList.splice(sort - 1, 1);
        } else {
          this.collegeList.splice(data.sort - 1, 0, { ...row });
          this.collegeList.splice(sort, 1);
        }
        console.log([...this.collegeList], "院校1");
        for (let i = 0; i < this.collegeList.length; i++) {
          this.collegeList[i].sort = i + 1;
          if (this.volunteerMode === 1) {
            if (this.collegeList[i].specialtyList) {
              this.collegeList[i].specialtyList.forEach((specialty) => {
                specialty.sort = this.collegeList[i].sort;
              });
            }
          }
        }
        console.log([...this.collegeList], "院校2");
        this.$emit("collegeList", this.collegeList);
      }
      if (this.volunteerMode === 3) {
        this.optionsList = [];
        this.collegeList.forEach((item) => {
          if (item.optionsList) {
            this.optionsList = [...this.optionsList, ...item.optionsList];
          }
        });
        this.optionsList.sort(function (a, b) {
          return a.sort - b.sort;
        });
        let sort = this.fatherSort;
        let row = this.optionsList[sort - 1];
        if (data.sort > this.optionsList.length) {
          data.sort = this.optionsList.length;
        }
        if (data.sort < 0 || data.sort - 0 === NaN) {
          data.sort = sort;
        }
        if (data.sort === sort) {
          return;
        }
        if (data.sort > sort) {
          this.optionsList.splice(data.sort, 0, row);
          this.optionsList.splice(this.fatherSort - 1, 1);
        } else {
          this.optionsList.splice(data.sort - 1, 0, row);
          this.optionsList.splice(this.fatherSort, 1);
        }
        for (let i = 0; i < this.optionsList.length; i++) {
          this.optionsList[i].sort = i + 1;
        }
        this.$emit("getOptions", this.optionsList);
      }
    },
    // 院校专业排序
    changesortSchoolspecialtyList(row) {
      this.collegeList.forEach((school) => {
        if (this.volunteerMode !== 3) {
          if (
            school.collegeName === row.collegeName &&
            school.specialtyOptions === row.specialtyOptions
          ) {
            // if (row.psort < 0 || row.psort - 0 === NaN) {
            //   row.psort = this.oldSOrt;
            // }
            // if (row.psort === this.oldSOrt) {
            //   return;
            // }

            // if (row.psort > school.specialtyList.length) {
            //   row.psort = school.specialtyList.length;
            // }
            // if (row.psort < 1) {
            //   row.psort = 1;
            // }
            // if (row.psort > this.oldSOrt) {
            //   school.specialtyList.splice(row.psort, 0, row);
            //   school.specialtyList.splice(this.oldSOrt - 1, 1);
            // } else {
            //   school.specialtyList.splice(row.psort - 1, 0, row);
            //   school.specialtyList.splice(this.oldSOrt, 1);
            // }
            // for (let i = 0; i < school.specialtyList.length; i++) {
            //   school.specialtyList[i].psort = i + 1;
            // }

            let oldIndex = this.oldSOrt;
            let data = { ...row };
            if (data.psort < 1) {
              data.psort = 1;
            }
            if (data.psort > school.specialtyList.length) {
              data.psort = school.specialtyList.length;
            }

            if (data.psort < oldIndex) {
              // 大于等于newSort 小于oldSort的sort+1
              school.specialtyList.forEach((item) => {
                let tempSort = parseInt(item.psort);
                if (
                  item.specialtyUuid !== data.specialtyUuid &&
                  item.psort >= data.psort &&
                  item.psort < oldIndex
                ) {
                  item.psort = tempSort + 1;
                }
                if (item.specialtyUuid === data.specialtyUuid) {
                  item.psort = data.psort;
                }
              });
            }

            if (data.psort > oldIndex) {
              //小于等于newSort 大于oldSort 的sort - 1
              school.specialtyList.forEach((item) => {
                let tempSort = parseInt(item.psort);
                if (
                  item.specialtyUuid !== data.specialtyUuid &&
                  item.psort > oldIndex &&
                  item.psort <= data.psort
                ) {
                  item.psort = tempSort - 1;
                }
                if (item.specialtyUuid === data.specialtyUuid) {
                  item.psort = data.psort;
                }
              });
            }
            school.specialtyList.sort(function (a, b) {
              return a.psort - b.psort;
            });
          }
        } else {
          if (school.collegeName === row.collegeName) {
            if (school.optionsList && school.optionsList.length > 0) {
              school.optionsList.forEach((options) => {
                if (
                  options.collegeName === row.collegeName &&
                  options.specialtyOptions === row.specialtyOptions
                ) {
                  // if (row.psort < 0 || row.psort - 0 === NaN) {
                  //   row.psort = this.oldSOrt;
                  // }
                  // if (row.psort === this.oldSOrt) {
                  //   return;
                  // }
                  // if (row.psort > options.specialtyList.length) {
                  //   row.psort = options.specialtyList.length;
                  // }
                  // if (row.psort < 1) {
                  //   row.psort = 1;
                  // }
                  // if (row.psort > this.oldSOrt) {
                  //   options.specialtyList.splice(row.psort, 0, row);
                  //   options.specialtyList.splice(this.oldSOrt - 1, 1);
                  // } else {
                  //   options.specialtyList.splice(row.psort - 1, 0, row);
                  //   options.specialtyList.splice(this.oldSOrt, 1);
                  // }
                  // for (let i = 0; i < options.specialtyList.length; i++) {
                  //   options.specialtyList[i].psort = i + 1;
                  // }

                  let oldIndex = this.oldSOrt;
                  let data = { ...row };
                  if (data.psort < 1) {
                    data.psort = 1;
                  }
                  if (data.psort > options.specialtyList.length) {
                    data.psort = options.specialtyList.length;
                  }

                  if (data.psort < oldIndex) {
                    // 大于等于newSort 小于oldSort的sort+1
                    options.specialtyList.forEach((item) => {
                      let tempSort = parseInt(item.psort);
                      if (
                        item.specialtyUuid !== data.specialtyUuid &&
                        item.psort >= data.psort &&
                        item.psort < oldIndex
                      ) {
                        item.psort = tempSort + 1;
                      }
                    });
                  }

                  if (data.psort > oldIndex) {
                    //小于等于newSort 大于oldSort 的sort - 1
                    options.specialtyList.forEach((item) => {
                      let tempSort = parseInt(item.psort);
                      if (
                        item.specialtyUuid !== data.specialtyUuid &&
                        item.psort > oldIndex &&
                        item.psort <= data.psort
                      ) {
                        item.psort = tempSort - 1;
                      }
                    });
                  }
                  options.specialtyList.sort(function (a, b) {
                    return a.psort - b.psort;
                  });
                }
              });
            }
          }
        }
      });

      this.specialtyList = [];
      this.collegeList.forEach((college) => {
        if (college.specialtyList) {
          this.specialtyList = [
            ...this.specialtyList,
            ...college.specialtyList,
          ];
        }
      });
      this.$emit("collegeList", this.collegeList);
      this.changeswitch();
      // this.setrowspans();
    },
    // 合并列斑马线展示
    tabRowClassName({ row, rowIndex }) {
      if (row.classStripe) {
        return "warning-row";
      }else if (row.type === 1) {
        return "chong";
      }else if (row.type === 2) {
        return "wen";
      }else if (row.type === 3) {
        return "bao";
      }

    },
    tableRowClassName({ row, rowIndex }) {
      console.log(rowIndex, "rowIndexrowIndex");
      if (rowIndex % 2 != 0) {
        console.log(rowIndex, "rowIndex % 2 == 0");

        return "warning-row";
      } else if (row.type === 2) {
        return "wen";
      } else if (row.type === 3) {
        return "bao";
      } else if (row.type === 1) {
        return "chong";
      }
      // if (this.switchValue === 1 && this.volunteerMode !== 3 && row.specialtyList) {
      //   if (row.specialtyList.length < 1) {
      //     return "warning-red";
      //   }
      // }
      // if (this.switchValue === 1 && this.volunteerMode !== 3 && !row.specialtyList) {
      //   return "warning-red";
      // }
      // if (this.switchValue === 1 && this.volunteerMode === 3 && row.optionsList) {
      //   if (row.optionsList.length < 1) {
      //     return "warning-red";
      //   }
      // }
      // if (this.switchValue === 1 && this.volunteerMode === 3 && !row.optionsList) {
      //   return "warning-red";
      // }
      // if (this.switchValue === 3 && this.volunteerMode === 3 && row.specialtyList) {
      //   if (row.specialtyList.length < 1) {
      //     return "warning-red";
      //   }
      // }
      // if (this.switchValue === 3 && this.volunteerMode === 3 && !row.specialtyList) {
      //   return "warning-red";
      // }
    },
    // 获取旧排名
    getOldSort(oldSOrt) {
      this.oldSOrt = oldSOrt;
    },
    getOldFatherSort(oldSOrt) {
      this.fatherSort = oldSOrt;
    },
    /**
     * 刷新数据
     * @param collegeList 批次下原料志愿
     */
    refreshData(collegeList) {
      if (collegeList) {
        this.collegeList = [...collegeList];
      } else {
        this.collegeList = [];
      }
      this.resetSpecialtyList();
      this.changeswitch();
    },
    resetSpecialtyList() {
      if (this.volunteerMode === 1 || this.volunteerMode === 2) {
        this.specialtyList = [];
        for (let i = 0; i < this.collegeList.length; i++) {
          this.specialtyList = [
            ...this.specialtyList,
            ...this.collegeList[i].specialtyList,
          ];
        }
      } else if (this.volunteerMode === 3) {
        this.specialtyList = [];
        for (let i = 0; i < this.collegeList.length; i++) {
          if (
            this.collegeList[i].optionsList &&
            this.collegeList[i].optionsList.length > 0
          ) {
            for (let y = 0; y < this.collegeList[i].optionsList.length; y++) {
              this.specialtyList = [
                ...this.specialtyList,
                ...this.collegeList[i].optionsList[y].specialtyList,
              ];
            }
          }
        }
      }
    },
    // 切换志愿视图
    changeswitch(val) {
      if (val) {
        this.switchValue = val;
      }
      console.log(
        "switchValue：" + this.switchValue + "，volunteerMode：" + this.volunteerMode,
        "切换志愿视图"
      );
      if (this.switchValue === 2 && this.volunteerMode !== 3) {
        this.specialtyList = [];
        if (this.collegeList && this.collegeList.length > 0) {
          this.collegeList.forEach((item) => {
            if (item.specialtyList && item.specialtyList.length > 0) {
              this.specialtyList = [
                ...this.specialtyList,
                ...item.specialtyList,
              ];
            } else {
              if (this.volunteerMode !== 2) {
                let maj = {
                  collegeCode: item.collegeCode,
                  collegeName: item.collegeName,
                  admitBatch: item.admitBatch,
                  specialtyOptions: item.specialtyOptions,
                  requiredType: item.requiredType,
                  specialtyUuid: item.collegeName + item.specialtyOptions,
                  sort: item.sort,
                  requiredDiscipline: item.requiredDiscipline,
                  scoreYearThis2: item.scoreYearThis,
                  accumulateYearThis2: item.accumulateYearThis,
                  accumulateYearLast2: item.accumulateYearLast,
                  accumulateYearOther2: item.accumulateYearOther,
                  planYearLast2: item.planYearLast,
                  planYearThis2: item.planYearThis,
                  planDiff2: item.planDiff,
                };
                this.specialtyList.push({ ...maj });
              }
            }
          });
        }

        if (this.volunteerMode === 2) {
          this.specialtyList.sort(function (a, b) {
            return a.psort - b.psort;
          });
          this.specialtyList.forEach((spe, ind) => {
            spe.psort = ind + 1;
          });
        } else {
          this.setrowspans();
        }
      }
      if (this.switchValue === 3 && this.volunteerMode === 3) {
        console.log(this.collegeList, "院校");
        this.optionsList = [];
        if (this.collegeList && this.collegeList.length > 0) {
          this.collegeList.forEach((item) => {
            if (item.optionsList) {
              this.optionsList = [...this.optionsList, ...item.optionsList];
            }
          });
        }
        this.optionsList.sort(function (a, b) {
          return a.sort - b.sort;
        });
        console.log(this.optionsList, "专业组志愿");
      }
      if (this.switchValue === 2 && this.volunteerMode === 3) {
        this.specialtyList = [];
        if (this.collegeList && this.collegeList.length > 0) {
          this.collegeList.forEach((item) => {
            if (item.optionsList && item.optionsList.length > 0) {
              item.optionsList.forEach((options) => {
                if (options.specialtyList && options.specialtyList.length > 0) {
                  this.specialtyList = [
                    ...this.specialtyList,
                    ...options.specialtyList,
                  ];
                } else {
                  this.specialtyList.push({
                    collegeCode: options.collegeCode,
                    collegeName: options.collegeName,
                    sort: options.sort,
                    specialtyUuid:
                      options.collegeName + options.specialtyOptions,
                    specialtyOptions: options.specialtyOptions,
                    specialtyNames: options.specialtyNames,
                    aspirationName: options.aspirationName,
                    requiredType: options.requiredType,
                    requiredDiscipline: options.requiredDiscipline,
                    scoreYearThis2: options.scoreYearThis,
                    accumulateYearThis2: options.accumulateYearThis,
                    accumulateYearLast2: options.accumulateYearLast,
                    accumulateYearOther2: options.accumulateYearOther,
                    planYearLast2: options.planYearLast,
                    planYearThis2: options.planYearThis,
                    planDiff2: options.planDiff,
                  });
                }
              });

              // this.specialtyList.sort(function (a, b) {
              //   return a.psort - b.psort;
              // });
            }
          });
        }
        //对所有专业进行排序
        this.specialtyList.sort(function (a, b) {
          if (a.sort === b.sort) {
            if (a.specialtyOptions === b.specialtyOptions) {
              return a.psort - b.psort;
            } else {
              return a.specialtyOptions.localeCompare(
                b.specialtyOptions,
                "zh-CN"
              );
            }
          } else {
            return a.sort - b.sort;
          }
        });
        this.setrowspans();
      }
      this.$nextTick(() => {
        // this.rowDrop();
      });
    },
    //计算合并位置
    setrowspans() {
      console.log("计算合并位置");
      // 先给所有的数据都加一个v.rowspan = 1
      this.specialtyList.forEach((v) => {
        v.rowspan = 1;
      });
      console.log(this.specialtyList, "this.specialtyList");
      // 双层循环
      for (let i = 0; i < this.specialtyList.length; i++) {
        for (let j = i + 1; j < this.specialtyList.length; j++) {
          if (
            this.specialtyList[i].collegeName ===
              this.specialtyList[j].collegeName &&
            this.specialtyList[i].specialtyOptions ===
              this.specialtyList[j].specialtyOptions
          ) {
            this.specialtyList[i].rowspan++;
            this.specialtyList[j].rowspan--;
            this.specialtyList[j].classStripe =
              this.specialtyList[i].classStripe;
          } else {
            this.specialtyList[j].classStripe =
              !this.specialtyList[i].classStripe;
          }
        }
        i = i + this.specialtyList[i].rowspan - 1;
        console.log(i, "i");
      }
    },
    //进行表格合并
    objectOneMethod({ row, column, rowIndex, columnIndex }) {
      if (this.volunteerMode === 1 && this.switchValue === 2) {
        if (
          columnIndex === 0 ||
          columnIndex === 3 ||
          columnIndex === 1 ||
          columnIndex === 2 ||
          columnIndex === 4 ||
          columnIndex === 5 ||
          columnIndex === 6 ||
          columnIndex === 7 ||
          columnIndex === 8 ||
          columnIndex === 9 ||
          columnIndex === 10
        ) {
          return {
            rowspan: row.rowspan,
            colspan: 1,
          };
        }
      }
      if (this.volunteerMode === 3 && this.switchValue === 2) {
        if (
          columnIndex === 0 ||
          columnIndex === 3 ||
          columnIndex === 1 ||
          columnIndex === 2 ||
          columnIndex === 4 ||
          columnIndex === 5 ||
          columnIndex === 6 ||
          columnIndex === 7 ||
          columnIndex === 8 ||
          columnIndex === 9 ||
          columnIndex === 10 ||
          columnIndex === 11 ||
          columnIndex === 12
        ) {
          return {
            rowspan: row.rowspan,
            colspan: 1,
          };
        }
      }
      // if (this.volunteerMode === 3 && this.switchValue === 3) {
      //   if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2) {
      //     return {
      //       rowspan: row.rowspan,
      //       colspan: 1,
      //     };
      //   }
      // }
    },
    // 编辑
    eidit(data) {
      if (this.volunteerMode !== 3 || this.switchValue === 3) {
        this.$emit("func", data);
      } else {
        this.$emit("editOptions", data);
      }
    },
    // 添加专业
    showaddmajor(data) {
      this.$emit("showaddmajor", data);
    },
    // 专业排序
    changesortspecialtyList(row, index) {
      // let data = this.specialtyList[index];
      // console.log(data, index);
      // if (data.psort > this.specialtyList.length) {
      //   data.psort = this.specialtyList.length;
      // }
      // let psort = index + 1 + "";
      // if (data.psort < 0 || data.psort - 0 === NaN) {
      //   data.psort = psort;
      // }
      // if (data.psort === psort) {
      //   return;
      // }
      // console.log([...this.specialtyList], "插入");
      // if (data.psort > psort) {
      //   this.specialtyList.splice(data.psort, 0, data);
      //   this.specialtyList.splice(index, 1);
      // } else {
      //   this.specialtyList.splice(data.psort - 1, 0, data);
      //   this.specialtyList.splice(index + 1, 1);
      // }
      // for (let i = 0; i < this.specialtyList.length; i++) {
      //   this.specialtyList[i].psort = i + 1;
      // }

      //原sort  index
      //现sort  data.psort
      let oldIndex = index + 1;
      let data = { ...row };
      if (data.psort < 1) {
        data.psort = 1;
      }
      if (data.psort > this.specialtyList.length) {
        data.psort = this.specialtyList.length;
      }

      if (data.psort < oldIndex) {
        // 大于等于newSort 小于oldSort的sort+1
        this.specialtyList.forEach((item) => {
          let tempSort = parseInt(item.psort);
          if (
            item.specialtyUuid !== data.specialtyUuid &&
            item.psort >= data.psort &&
            item.psort < oldIndex
          ) {
            item.psort = tempSort + 1;
          }
          if (item.specialtyUuid === data.specialtyUuid) {
            item.psort = data.psort;
          }
        });
      }

      if (data.psort > oldIndex) {
        //小于等于newSort 大于oldSort 的sort - 1
        this.specialtyList.forEach((item) => {
          let tempSort = parseInt(item.psort);
          if (
            item.specialtyUuid !== data.specialtyUuid &&
            item.psort > oldIndex &&
            item.psort <= data.psort
          ) {
            item.psort = tempSort - 1;
          }
          if (item.specialtyUuid === data.specialtyUuid) {
            item.psort = data.psort;
          }
        });
      }
      this.specialtyList.sort(function (a, b) {
        return a.psort - b.psort;
      });

      this.$emit("delspecialtyList", this.specialtyList);
    },
    //院校排序
    changesortcollegeList(row, index) {
      // let data = this.collegeList[index];
      // console.log(data, index);
      // let sort = index + 1 + "";
      // if (data.sort < 0 || data.sort - 0 === NaN) {
      //   data.sort = sort;
      // }
      // if (data.sort === sort) {
      //   return;
      // }
      // if (data.sort > this.collegeList.length) {
      //   data.sort = this.collegeList.length;
      // }
      // console.log(this.collegeList, "插入");
      // if (data.sort > sort) {
      //   this.collegeList.splice(data.sort, 0, data);
      //   this.collegeList.splice(index, 1);
      // } else {
      //   this.collegeList.splice(data.sort - 1, 0, data);
      //   this.collegeList.splice(index + 1, 1);
      // }
      // for (let i = 0; i < this.collegeList.length; i++) {
      //   this.collegeList[i].sort = i + 1;
      //   if (this.volunteerMode === 1) {
      //     if (this.collegeList[i].specialtyList) {
      //       this.collegeList[i].specialtyList.forEach((specialty) => {
      //         specialty.sort = i + 1;
      //       });
      //     }
      //   }
      // }

      let oldIndex = index + 1;
      let data = { ...row };
      if (data.sort < 1) {
        data.sort = 1;
      }
      if (data.sort > this.collegeList.length) {
        data.sort = this.collegeList.length;
      }
      if (data.sort < oldIndex) {
        // 大于等于newSort 小于oldSort的sort+1
        this.collegeList.forEach((item) => {
          let tempSort = parseInt(item.sort);
          if (
            item.specialtyUuid !== data.specialtyUuid &&
            item.sort >= data.sort &&
            item.sort < oldIndex
          ) {
            item.sort = tempSort + 1;
          }
          if (item.specialtyUuid === data.specialtyUuid) {
            item.sort = data.sort;
          }
        });
      }

      if (data.sort > oldIndex) {
        //小于等于newSort 大于oldSort 的sort - 1
        this.collegeList.forEach((item) => {
          let tempSort = parseInt(item.sort);
          if (
            item.specialtyUuid !== data.specialtyUuid &&
            item.sort > oldIndex &&
            item.sort <= data.sort
          ) {
            item.sort = tempSort - 1;
          }
          if (item.specialtyUuid === data.specialtyUuid) {
            item.sort = data.sort;
          }
        });
      }
      this.collegeList.sort(function (a, b) {
        return a.sort - b.sort;
      });

      for (let i = 0; i < this.collegeList.length; i++) {
        if (this.volunteerMode === 1) {
          if (this.collegeList[i].specialtyList) {
            this.collegeList[i].specialtyList.forEach((specialty) => {
              specialty.sort = i + 1;
            });
          }
        }
      }

      this.$emit("collegeList", this.collegeList);
    },
    //删除院校志愿
    delcollegeList(index) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.collegeList.splice(index, 1);

        for (let i = index; i < this.collegeList.length; i++) {
          this.collegeList[i].sort = this.collegeList[i].sort - 1;
          if (this.volunteerMode === 1) {
            this.collegeList[i].specialtyList.forEach((specialty) => {
              specialty.sort = this.collegeList[i].sort;
            });
          }
        }
        if (this.volunteerMode === 1 || this.volunteerMode === 2) {
          this.specialtyList = [];
          for (let i = 0; i < this.collegeList.length; i++) {
            this.specialtyList = [
              ...this.specialtyList,
              ...this.collegeList[i].specialtyList,
            ];
          }
        } else if (this.volunteerMode === 3) {
          this.specialtyList = [];
          for (let i = 0; i < this.collegeList.length; i++) {
            if (
              this.collegeList[i].optionsList &&
              this.collegeList[i].optionsList.length > 0
            ) {
              for (let y = 0; y < this.collegeList[i].optionsList.length; y++) {
                this.specialtyList = [
                  ...this.specialtyList,
                  ...this.collegeList[i].optionsList[y].specialtyList,
                ];
              }
            }
          }
        }
        this.$emit("collegeList", this.collegeList);
      });
    },
    //删除专业志愿
    delspecialtyList(index, isShoolMarjor) {
      console.log(
        "isShoolMarjor：" + isShoolMarjor + ", volunteerMode：" + this.volunteerMode,
        "删除专业"
      );
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        if (isShoolMarjor) {
          if (this.volunteerMode !== 3) {
            let row = this.specialtyList[index];
            this.collegeList.forEach((school, ind) => {
              if (school.collegeName === row.collegeName) {
                if (row.specialtyName) {
                  school.specialtyList.splice(row.psort - 1, 1);
                  school.specialtyList.sort(function (a, b) {
                    return a.psort - b.psort;
                  });
                  school.specialtyList.forEach((marjor, ind) => {
                    marjor.psort = ind + 1;
                  });
                } else {
                  this.collegeList.splice(ind, 1);
                  for (let i = ind; i < this.collegeList.length; i++) {
                    this.collegeList[i].sort = this.collegeList[i].sort - 1;
                  }
                  if (this.volunteerMode === 1) {
                    this.collegeList[i].specialtyList.forEach((specialty) => {
                      specialty.sort = this.collegeList[i].sort;
                    });
                  }
                }
              }
            });
            this.specialtyList = [];
            this.collegeList.forEach((college) => {
              if (college.specialtyList) {
                this.specialtyList = [
                  ...this.specialtyList,
                  ...college.specialtyList,
                ];
              }
            });
            this.$emit("collegeList", this.collegeList);
          } else {
            let row = this.specialtyList[index];
            this.collegeList.forEach((school) => {
              if (school.collegeName === row.collegeName) {
                if (school.optionsList && school.optionsList.length > 0) {
                  school.optionsList.forEach((options) => {
                    if (
                      options.collegeName === row.collegeName &&
                      options.specialtyOptions === row.specialtyOptions
                    ) {
                      if (row.specialtyName) {
                        options.specialtyList.splice(row.psort - 1, 1);
                        options.specialtyList.sort(function (a, b) {
                          return a.psort - b.psort;
                        });
                        options.specialtyList.forEach((marjor, ind) => {
                          marjor.psort = ind + 1;
                        });
                        this.$emit("collegeList", this.collegeList);
                      } else {
                        this.optionsList = [];
                        this.collegeList.forEach((item) => {
                          if (item.optionsList) {
                            this.optionsList = [
                              ...this.optionsList,
                              ...item.optionsList,
                            ];
                          }
                        });
                        this.optionsList.sort(function (a, b) {
                          return a.sort - b.sort;
                        });
                        this.optionsList.forEach((option, index1) => {
                          if (
                            option.collegeName === row.collegeName &&
                            options.specialtyOptions === row.specialtyOptions
                          ) {
                            this.optionsList.splice(index1, 1);
                            for (
                              let i = index1;
                              i < this.optionsList.length;
                              i++
                            ) {
                              this.optionsList[i].sort =
                                this.optionsList[i].sort - 1;
                            }
                            this.$emit("getOptions", this.optionsList);
                          }
                        });
                      }
                    }
                  });
                }
              }
            });
            this.specialtyList = [];
            this.collegeList.forEach((college) => {
              if (college.optionsList) {
                college.optionsList.forEach((option) => {
                  if (option.specialtyList) {
                    this.specialtyList = [
                      ...this.specialtyList,
                      ...option.specialtyList,
                    ];
                  }
                });
              }
            });
          }
          this.changeswitch();
          // this.setrowspans();
        } else {
          if (this.specialtyList[index].specialtyName) {
            this.specialtyList.splice(index, 1);
            for (let i = index; i < this.specialtyList.length; i++) {
              this.specialtyList[i].psort = this.specialtyList[i].psort - 1;
            }
            this.$emit("delspecialtyList", this.specialtyList);
          } else {
            this.collegeList.forEach((item, ind) => {
              if (
                item.collegeName === this.specialtyList[index].collegeName &&
                item.collegeCode === this.specialtyList[index].collegeCode
              ) {
                this.collegeList.splice(ind, 1);
                for (let i = ind; i < this.collegeList.length; i++) {
                  this.collegeList[i].sort = this.collegeList[i].sort - 1;
                }
                this.$emit("collegeList", this.collegeList);
              }
            });
          }
        }
      });
    },

    matchRunType(data) {
      switch (data) {
        case 0:
          return "全部";
        case 1:
          return "公办";
        case 2:
          return "民办";
        case 3:
          return "其他";
        default:
          return "";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.all {
  .switch {
    float: right;
    margin-bottom: 10px;
  }

  .colorRed {
    color: rgb(230, 77, 77);
  }

  .table {
    padding-top: 30px;
  }

  .footerbox {
    margin-top: 40px;
    margin-bottom: 30px;
  }
}

.el-table {
  // /deep/.chong {
  //   background-color: #ffffff !important;
  // }
  // /deep/.wen {
  //   background-color: #ebfcf5 !important;
  // }
  // /deep/.bao {
  //   background-color: #caf8e4 !important;
  // }
  /deep/ .warning-row {
    background: #ecf8f0;
    // background: #fafafa;
    // background: red;
  }

  /deep/ .warning-red {
    background: #f79e9e !important;
    // color: #ffffff!important;
  }
}
</style>
